{
    "roleDetails": "Role Details",
    "roleId": "Role ID",
    "roleName": "Role Name",
    "clientId": "Client ID",
    "ssoDefaultRole": "SSO Default Role",
    "yes": "Yes",
    "no": "No",
    "createdAt": "Created At",
    "updatedAt": "Updated At",
    "never": "Never",
    "assignedUsers": "Assigned Users",
    "assignedViews": "Assigned Views",
    "assignedRights": "Assigned Rights",
    "usersAssigned": "users assigned",
    "viewsAssigned": "views assigned",
    "rightsAssigned": "rights assigned",
    "loadingRoleDetails": "Loading role details...",
    "roleDeleted": "Role deleted successfully",
    "selectClient": "Select Client",
    "checkingRoleDeletion": "Would you like to delete the selected role?",
    "roleSavedSuccessfully": "Role saved successfully"

}